import React from 'react';
import { Building2, HardHat, Clock } from 'lucide-react';

const StatsBar = () => {
    const stats = [
        {
            id: 1,
            icon: <Building2 size={32} />,
            value: "100+",
            label: "Projects Completed"
        },
        {
            id: 2,
            icon: <HardHat size={32} />,
            value: "6",
            label: "Ongoing Projects"
        },
        {
            id: 3,
            icon: <Clock size={32} />,
            value: "15+",
            label: "Years Experience"
        }
    ];

    return (
        <div className="bg-primary py-12">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-orange-700/50">
                    {stats.map((stat) => (
                        <div key={stat.id} className="flex flex-col items-center justify-center text-center p-4 text-white">
                            <div className="mb-3 opacity-90">
                                {stat.icon}
                            </div>
                            <div className="text-4xl font-bold mb-1">{stat.value}</div>
                            <div className="text-orange-100 font-medium uppercase tracking-wider text-sm">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StatsBar;
